import {Component, Input} from '@angular/core';
import * as moment from "moment";
import {ShopBaseComponent} from "../../shop/shop-base.component";
import {Company} from "../../../models/company";

@Component({
    selector: 'ui-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent extends ShopBaseComponent {

    @Input() shopLayout?: boolean = false;
    @Input() company: Company = new Company();

    showCompanyInfo: boolean = false;
    currentYear: number = moment().year();

    isMobileDevice(): boolean {
        return window.innerWidth < 768;
    }

}
